import * as Yup from 'yup';

export const verifyPhoneSchema = Yup.object().shape({
    phone: Yup.string().phone().required(),
    code: Yup.string().min(6).max(6).required(),
});
